import { Button } from 'antd';
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Payer } from '../../shared/models/payer.model';
import ApplicationDetail from '../../shared/services/applicationDetail.service';
import { RootState } from '../../store';
import { downloadMetricsBoardPDF } from '../../store/actions/dashboardAction';
import { customGTMEvent } from '../crm/inPatient/service/crmUtils';

const ExtraContent = ({
  sideForm,
}: any): ReactElement => {
  const appDetail = ApplicationDetail.instance;
  const groupProviders = appDetail?.getGroupProviders();
  const dispatch = useDispatch();
  const { type } = sideForm.getFieldsValue(['type']);

  const {
    metricsBoardFilter, isMetricsBoardPDFDownload, dashboardType,
   } = useSelector((state: RootState): any => state?.dashboard || {});

  const updateData = (data: any): string =>
    String(data?.map( (d: any): string => `\'${d}\'`));

  const downloadBtnClickHandler = (): void => {
    const filters: any =  [];

    if (metricsBoardFilter?.searchCenter) {
      filters.push({
        property: 'IHXHospitalID',
        values: updateData(metricsBoardFilter?.searchCenter),
      });
    } else if (groupProviders?.length > 0) {
      filters.push({
        property: 'IHXHospitalID',
        values: String(groupProviders?.map((ele: Payer): any => `\'${ele?.key}\'`)),
      });
    } else {
      filters.push({
        property: 'IHXHospitalID',
        values: String([`\'${appDetail?.getProviderId()}\'`]),
      });
    }

    if (metricsBoardFilter?.searchPayer) {
      filters.push({
        property: 'FinalPayerName',
        values: updateData(metricsBoardFilter?.searchPayer),
      });
    }

    if (type) {
      filters.push(
        {
          property: 'CorporateType',
          values: String([`\'${type}\'`]),
        },
      );
    }

    if (metricsBoardFilter?.fromMonth && metricsBoardFilter?.toMonth) {
      const startDate: any = new Date(metricsBoardFilter?.fromMonth);
      const endDate: any = new Date(metricsBoardFilter?.toMonth);
      const updatedStartDate: any =
        new Date(`${startDate?.getMonth() + 1} ${startDate?.getDate()} ${startDate?.getFullYear()} 00:00:01 UTC`);
      const updatedEndDate: any = new Date(`${endDate?.getMonth() + 1} ${endDate?.getDate()} ${endDate?.getFullYear()} 23:59:59 UTC`);

      filters.push({
        property: 'ClaimSubmittedDate',
        values: `\'${new Date(updatedStartDate).toJSON().slice(0, -1)}\',\'${new Date(updatedEndDate).toJSON().slice(0, -1)}\'`,
      });
    }

    dispatch(downloadMetricsBoardPDF({
      filters,
      dashboardType,
    }));
    customGTMEvent({
      event: 'Download - Metrics Board',
      dashboardType,
    });
  };

  return (
    <Button
      type="link"
      onClick={downloadBtnClickHandler}
      loading={isMetricsBoardPDFDownload}
    >
      <img
        src={`${process.env.REACT_APP_COMMON_BUCKET_URL}svg-assets/download-icon.svg`}
        className="mr-5"
        alt={'Download Icon'}
       />
        Download
      </Button>
  );
};

export default ExtraContent;
